import React from 'react'
import cx from 'classnames'
import * as R from 'ramda'
import { t } from 'ttag'

import { DoubleConfirmationModal } from 'components/modals/DoubleConfirmationModal/DoubleConfirmationModal'
import { Form } from 'components/shared/Form/Form'
import { Modal } from 'components/shared/Modal/Modal'
import { TabsBar } from 'components/shared/TabsBar/TabsBar'

import { TAB_NAMES } from './model'

import styles from './JobPositionModal.module.scss'

export const JobPositionModal = ({
  activeTab,
  tab,
  tabs = [],
  title,
  onBack,
  onCancel,
  onClose,
  onConfirm,
  onConfirmationClose,
  onConfirmationConfirm,
  onTab,
  isConfirmationOpen,
  isOpen,
  isLastStep,
}) => (
  <>
    <Modal
      backLabel={onBack ? t`Back` : null}
      cancelLabel={t`Cancel`}
      confirmLabel={isLastStep ? t`Save` : t`Next`}
      className={cx(styles.modal, {
        [styles.competencies]: R.equals(activeTab, TAB_NAMES.COMPETENCIES),
        [styles.details]: R.equals(activeTab, TAB_NAMES.DETAILS),
        [styles.modules]: R.equals(activeTab, TAB_NAMES.MODULES),
        [styles.outcome]: R.equals(activeTab, TAB_NAMES.PRIORITISED_OUTCOME),
        [styles.access]: R.equals(activeTab, TAB_NAMES.ACCESS),
      })}
      {...{ title, onBack, onCancel, onClose, onConfirm, isOpen }}
    >
      <Modal.Header />
      <Modal.Content className={styles.content}>
        <TabsBar
          className={styles.tabs}
          tabClassName={styles.tab}
          onClick={onTab}
          isCentered
          isOutlined
          {...{ activeTab, tabs }}
        />
        <Form className={styles.form}>{tab}</Form>
      </Modal.Content>
      <Modal.Footer />
    </Modal>
    <DoubleConfirmationModal
      onCancel={onConfirmationClose}
      onClose={onConfirmationClose}
      onConfirm={onConfirmationConfirm}
      isOpen={isConfirmationOpen}
    />
  </>
)
